import StyledMain, { StyledFooter } from './styles';

import AnaliseRemota from './components/AnaliseRemota';
import BottomPanel from './components/BottomPanel';
import Map from './components/Map';
import MapCoordinates from './components/MapCoordinate';
import MiniMap from './components/MiniMap';
import PRA from './components/PRA';
import Scale from './components/Scale';
import SEIA from './components/SEIA';


import AppContext from '../../services/context';
import { LogoINEMA } from '../Icons/Inema';
import { LogoTCSA } from '../Icons/Logo_TCSA';

import convert from 'color-convert';
import * as Vibrant from 'node-vibrant';
/**
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useContext usado para forcener uma maneira de passar dados
 * pela arvore de componentes sem ter que passar props manualmente
 * em todos os níveis.
 */
import { useEffect, useState, useContext } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useModule, useMap } from 'views/MapView/hooks';

const MapArea = (props) => {
  const [palette, setPalette] = useState(null);
  const appContext = useContext(AppContext);

  const {
    setThemeVariables,
    bottomPanelIsOpen,
    setBottomPanelIsOpen,
    setHidedInterface,
  } = appContext;

  const { activeModule, getElement } = useModule();
  const { map, resetMap } = useMap();

  useEffect(() => {
    if (activeModule) {
      const v = new Vibrant(activeModule.icone);
      v.getPalette().then((paramPalette) => setPalette(paramPalette));

      setBottomPanelIsOpen(false);
      setHidedInterface(false);
    }
  }, [
    activeModule,
    resetMap,
    setBottomPanelIsOpen,
    setHidedInterface,
    getElement,
  ]);

  useEffect(() => {
    if (palette) {
      const hsl = convert.hex.hsl(palette.Muted.hex);
      // luminosidade mínima da cor primária 40%, não pode ser muito escuro
      // luminosidade máxima da cor primária 60%, não pode ser muito claro
      // const luminosity = hsl[2] > 60 ? 60 : hsl[2] < 40 ? 40 : hsl[2];
      setThemeVariables({
        primaryColor: `hsl(${hsl[0] + 1}, ${hsl[1]}%, ${hsl[2] + 25}%)`,
        primaryColorDark: `hsl(${hsl[0] + 3}, ${hsl[1] - 27}%, ${hsl[2] - 9}%)`,
        secondaryColorDark: `hsl(${hsl[0] - 4}, ${hsl[1] - 15}%, ${
          hsl[2] - 12
        }%)`,
      });

      let metaThemeColor = document.querySelector('meta[name=theme-color]');
      metaThemeColor.setAttribute('content', palette.Muted.hex);
    }
  }, [palette, setThemeVariables]);

  /**
   * TODO avaliar se o melhor lugar para essa lógica estar é aqui...
   * Poderia estar atrelada com o método de abertura do bottomPanel no context
   */
  useEffect(() => {
    if (bottomPanelIsOpen && window.innerWidth < 768) {
      setHidedInterface(true);
    } else {
      setHidedInterface(false);
    }
  }, [bottomPanelIsOpen, setHidedInterface]);

  return (
    <StyledMain>
      {/* 
        * Esse bloco de código exibe a paleta de cores utilizada
        * na interface retirada da logo.

        {palette && (
          <div className="palette">
            {Object.values(palette).map((p) => {
              return <div style={{ backgroundColor: p.hex }} />;
            })}
          </div>
        )} 
      
      */}
      {getElement('CPN-MA-MAP') && <Map />}
      {getElement('CPN-MA-PRA') && <PRA />}
      {getElement('CPN-MA-SEIA') && <SEIA />}
      {getElement('CPN-MA-ANALISE-REMOTA') && <AnaliseRemota />}
      {getElement('CPN-MA_MINIMAP') && <MiniMap />}
      {map && (
        <div className="bottomRight">
          <Scale map={map} />
          {getElement('CPN-MA_MAP-COORDINATE') && <MapCoordinates />}
        </div>
      )}
      {appContext.bottomPanelIsOpen && (
        <BottomPanel
          menuPanelIsHided={appContext.hidedInterface}
          hideMenuPanel={(hide) => {
            setHidedInterface(hide);
            // eslint-disable-next-line no-underscore-dangle
            map._onResize();
          }}
          onClose={() => appContext.setBottomPanelIsOpen(false)}
          title={appContext.bottomPanelTitle}
        >
          {appContext.bottomPanelContent}
        </BottomPanel>
      )}
      <StyledFooter>
        <LogoTCSA/>
        <LogoINEMA/>
      </StyledFooter> 
    </StyledMain>
  );
};

MapArea.properties = {
  id: 'CPN-MAP_AREA',
  alias: 'Área do mapa',
  description: '...',
};

export default MapArea;
